import { lazy } from "react"
import { Routes, Route } from "react-router-dom"

import NoMatch from "components/no-match"

import RequireNoAuth from "./require-no-auth"
import RequireAuth from "./require-auth"
import PermissionError from "modules/error/permission-error"
import RequirePermission from "./require-permission"
import Maintenance from "modules/error/maintenance"
import EmailChangeConfirm from "pages/auth/email-change-confirm"
import AuthLayout from "modules/layout/auth"

const Auth = lazy(
  () => import(/* webpackChunkName: "[auth]" */ "../../pages/auth")
)
const Home = lazy(
  () => import(/* webpackChunkName: "[Home]" */ "../../pages/home")
)
const Profile = lazy(
  () => import(/* webpackChunkName: "[profile]" */ "../../pages/user/profile")
)
const Configuration = lazy(
  () =>
    import(
      /* webpackChunkName: "[configuration]" */ "../../pages/configuration"
    )
)
const Operations = lazy(
  () => import(/* webpackChunkName: "[operations]" */ "../../pages/operations")
)
const ASuite = lazy(
  () => import(/* webpackChunkName: "[A-Suite]" */ "../../pages/a-suite")
)
const Reports = lazy(
  () => import(/* webpackChunkName: "[reports]" */ "../../pages/reports")
)
const Tactic = lazy(
  () => import(/* webpackChunkName: "[reports]" */ "../../pages/tactic")
)

const Router: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <RequireAuth>
            <Home />
          </RequireAuth>
        }
      />
      <Route
        path="/auth/*"
        element={
          <RequireNoAuth>
            <Auth />
          </RequireNoAuth>
        }
      />
      <Route path="/auth/email-change/confirm" element={<AuthLayout />}>
        <Route index element={<EmailChangeConfirm />} />
      </Route>
      <Route
        path="/user/profile/*"
        element={
          <RequireAuth>
            <Profile />
          </RequireAuth>
        }
      />
      <Route
        path="/configuration/*"
        element={
          <RequireAuth>
            <RequirePermission to="configuration" type="services">
              <Configuration />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/operations/*"
        element={
          <RequireAuth>
            <RequirePermission to="operation" type="services">
              <Operations />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/a-suite/*"
        element={
          <RequireAuth>
            <RequirePermission to="suite" type="services">
              <ASuite />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/*"
        element={
          <RequireAuth>
            <RequirePermission to="reports" type="services">
              <Reports />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route
        path="/tactic/*"
        element={
          <RequireAuth>
            <RequirePermission to="tactical" type="services">
              <Tactic />
            </RequirePermission>
          </RequireAuth>
        }
      />
      <Route path="/permission-error" element={<PermissionError />} />
      <Route path="/maintenance" element={<Maintenance />} />
      <Route path="*" element={<NoMatch />} />
    </Routes>
  )
}

export default Router
